export default defineNuxtRouteMiddleware((_to, _from) => {
  const { floristInfo, isInternalUser } = useFloristInfoStore();
  const isXlFloristsActive = isFeatureFlagActive(FeatureFlag.XlFlorists);

  if (!isXlFloristsActive || (!floristInfo.isXL && !isInternalUser)) {
    return navigateTo('/');
  }
});
